export const ROI_MESSAGES = {
  DELETE_ROI: "Delete Region of interest",
  DELETE_CONFIRMATION_TEXT: "Are you sure you’d like to delete this region of interest? If yes, you will no longer receive",
  DELETE_CONFIRMATION_TEXT_CONTINUE: "alerts or analytics in this region.",
  MODAL_TYPE: "Delete"
};

export const DEPLOY_MODAL_MESSAGES = {
  RE_DEPLOY : "Re-Deploy cvapp",
  CONFIRM_BODY_TEXT : "Are you sure you’d like to re-deploy this ",
  CONFIRM_BODY_TEXT_CONTINUE: "cvapp ?",
  CONFIRM_BUTTON: "Yes, re-deploy",
  MODAL_TYPE: "Update",
}

export const DEPLOY_API = {
  SUCCESS: "Re deployed successfully.",
  SUCESS_MESSAGE: "You have successfully re deployed the selected roi cvapp.",
  FAILED: "Re deploy failed",
  FAILED_MESSAGE: "Failed to re deploy the selected roi cvapp.",
};